module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-800-heavy-5a4f248e9aa3d6fe6c0c643d6b6af2f4.woff";